import { ComponentType } from "react";
import { InkleTaxSymbol } from "components/icons/Logos/InkleTaxSymbol";
import { InkleBooksSymbol } from "components/icons/Logos/InkleBooksSymbol";
import { InkleCommunitySymbol } from "components/icons/Logos/InkleCommunitySymbol";
import { InkleIntragroupSymbol } from "components/icons/Logos/InkleIntragroupSymbol";
import { InkleMailroomSymbol } from "components/icons/Logos/InkleMailroomSymbol";
import { InkleSalesTaxSymbol } from "components/icons/Logos/InkleSalesTaxSymbol";
import { ConditionalLink } from "components/conditionalLink";
import { usePageTitle } from "hooks/usePageTitle";
import { InkleTaxCreditSymbol } from "components/icons/Logos/InkleTaxCreditSymbol";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useLocation } from "react-router-dom";
import { useQuery } from "hooks/useQuery";

export const AppTile = ({
  logo: Logo,
  link,
  name,
}: {
  logo: ComponentType;
  link: string;
  name: string;
}) => {
  return (
    <ConditionalLink
      to={link}
      className="t-text-text-100 hover:t-text-text-100 t-no-underline t-flex t-flex-col t-items-center t-gap-2"
    >
      <div className="t-w-24 t-h-24 t-flex t-items-center t-justify-center app-switcher-gradient t-rounded-xl t-border t-border-solid t-border-neutral-10 t-shadow-xs hover:t-shadow-light-60 hover:t-border-purple-20 hover:t-scale-105 t-transition-all t-duration-200">
        <Logo />
      </div>
      <span className="t-text-body-sm">{name}</span>
    </ConditionalLink>
  );
};

export const AppSwitcher = () => {
  usePageTitle("Apps");
  const search = useQuery();
  const popup = search.get("popupgeneral");
  const { link } = useConstructInternalLink();

  const linkWithPopup = (url: string) =>
    popup ? link(url, { keys: ["popupgeneral"] }) : link(url);

  return (
    <div className="t-flex t-flex-col t-h-screen t-justify-center t-items-center t-gap-10 sm:t-px-4">
      <p className="t-text-title-h1 t-m-0 t-text-text-100">
        Choose an app to go to
      </p>
      <div className="t-flex t-gap-10 sm:t-gap-4">
        <AppTile
          logo={InkleBooksSymbol}
          link={linkWithPopup("/books")}
          name="Books"
        />
        <AppTile
          logo={InkleTaxSymbol}
          link={linkWithPopup("/tax")}
          name="Tax"
        />
        <AppTile
          logo={InkleSalesTaxSymbol}
          link={linkWithPopup("/sales-tax")}
          name="Sales Tax"
        />
      </div>
      <div className="t-flex t-gap-10 t-mt-10 sm:t-gap-4">
        <AppTile
          logo={InkleMailroomSymbol}
          link={linkWithPopup("/mailroom")}
          name="Mailroom"
        />
        <AppTile
          logo={InkleCommunitySymbol}
          link={linkWithPopup("/community")}
          name="Community"
        />
      </div>
    </div>
  );
};
